import { render } from "./Tasks.vue?vue&type=template&id=0cedb24e&scoped=true"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"

import "./Tasks.vue?vue&type=style&index=0&id=0cedb24e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cedb24e"]])

export default __exports__